export default __webpack_public_path__ + "static/media/kitchen3-afterB.9ec8d6f9.jpg";